import React from "react";

import {
  Button,
  Row, Col,
  Modal, ModalBody, ModalFooter
} from "reactstrap";

import InputText from '../FormParts/InputText';
import { template } from "../../variables/memoTemplate";
import InputSelect from '../FormParts/InputSelect';
import InputCheckBox from "../FormParts/InputCheckBox";
import Request from '../../common/Request';
import { getErrorCodes } from "../../variables/message";

export default class MemoPopup extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      data: {
        values: {},
        requiredData: {},
        errors: {},
      },
      userData: [],
    };

    this.toggleModal = this.toggleModal.bind(this)
    this.validateCallBack = this.validateCallBack.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: {
          ...this.props.data,
          values : {
            ...this.props.data.values
          },
          errors : {}
        }
      })
    }
  }

  validateCallBack(newData, callback = () => { }) {
    const data = this.state.data;
    this.setState({
      data: {
        ...data,
        ...newData
      }
    }, () => callback())
  }

  copyToContectMemo() {
    const seletedMemo = this.state.data.values.temp_contact_memo || "";
    this.setState({
      data: {
        ...this.state.data,
        values: {
          ...this.state.data.values,
          contact_memo: seletedMemo
        }
      }
    })
  }

  show() {
    this.setState({ modal: true });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true
  }

  render() {
    return (
      <Modal size="sm" isOpen={this.state.modal}>
        <div className="modal-header">
          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => this.toggleModal()}>
            <i className="tim-icons icon-simple-remove"></i>
          </button>
          <h5 className="modal-title float-left">顧客連絡メモ</h5>
        </div>
        <ModalBody>
          <Row>
            <Col><h5 className="float-left" style={{color:"red"}}>顧客システムの利用者へ通知されます</h5></Col>
          </Row>
          <Row>
            <Col>
              <InputSelect
                label="顧客連絡用コメント候補"
                labelOn={true}
                name="TEMP__temp_contact_memo"
                options={template}
                rootData={this.state.data}
                validateCallback={this.validateCallBack}
                isSearchable={true}
              />
              <Button style={{ marginTop: 10 }} onClick={() => this.copyToContectMemo()}>選択した候補を下へコピー</Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <InputText
                name="TEMP__contact_memo"
                label="顧客連絡用コメント"
                labelOn={true}
                validateCallback={this.validateCallBack}
                multiline={true}
                rootData={this.state.data}
                validateType='regist'
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button style={{ margin: '0 auto' }} color="" onClick={this.toggleModal}>
            キャンセル
          </Button>
          <Button style={{ margin: '0 auto' }} color="info"
            onClick={() => {
              if(this.validate()){  
                this.props.updateMemo(this.state.data.values);
                this.toggleModal();
              }
            }}>
            更新する
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}